import {
  Box,
  Button,
  Divider,
  MenuItem,
  Popover,
  Select,
  TextField,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import moment from "moment";
import { GadsWrapper } from "./styles";
import { Controller, useForm } from "react-hook-form";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import CircleRoundedIcon from "@mui/icons-material/CircleRounded";

import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useApi } from "../../hooks/useApi.hook";
import MeetingService from "../../services/api/meeting.service";
import { ControlForm, Modal } from "../../components";
import { toggleMessage } from "../../components/Toast/Toast";
import {
  ICreateMeetingScheduleReq,
  IMeetingRoom,
  IMeetingSchedule
} from "../../models/meeting";
import { DATETIME_FORMAT3 } from "../../config/constants";
import InputForm from "../../components/controls/InputForm";
import ReportEmbed from "../../components/Embeb/ReportEmbed";
import { ICompany, IUpdateGoogleAds } from "../../models/company";
import CompanyService from "../../services/api/company.service";
import variableStyles from "../../theme/variable-styles";

const GCSL = () => {
  const now = moment().add(5, "minutes").format(DATETIME_FORMAT3);
  const [openCreate, setOpenCreate] = useState<boolean>(false);
  const [endDateTime, setEndDateTime] = useState<any>(null);
  const [beginDateTime, setBeginDateTime] = useState<any>(now);
  // const [duration, setDuration] = useState<number>(30);
  // const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const getGoooleAds = useApi<ICompany>({ isFetch: true });
  const updateGAds = useApi<IUpdateGoogleAds>({});

  const [goooleAds, setGoooleAds] = useState<ICompany | undefined>(undefined);

  function fetchData() {
    getGoooleAds.request(CompanyService.getGoogleAds());
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setGoooleAds(getGoooleAds.data);
    setValue("iframeGoogleReport", getGoooleAds.data?.iframeGoogleReport);
    // setValue("leaderId", getSingle.data?.leaderId);
  }, [getGoooleAds.data]);

  const validationSchema = Yup.object().shape({
    iframeGoogleReport: Yup.string().required(
      `${"Vui lòng iframe google console"}`
    )
  }) as any;
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm<ICompany>({
    resolver: yupResolver(validationSchema)
  });

  const onSubmit = (request: ICompany) => {
    const req: IUpdateGoogleAds = {
      iframeGoogleReport: request.iframeGoogleReport,
      type: 1
    };
    updateGAds.request(
      CompanyService.updateGoogleAds(req).then(res => {
        if (res.success) {
          toggleMessage({
            type: "success",
            message: res.message ? res.message : ""
          });
          fetchData();
          setOpenCreate(false);
          reset();
        }
      })
    );
  };

  return (
    <GadsWrapper>
      <Box>
        <div>
          <Button
            variant="contained"
            size="small"
            aria-label="aria-modal"
            onClick={() => {
              // meetingRoom.request(
              //   MeetingService.getRooms({
              //     CurrentPage: 1,
              //     PageSize: 10
              //   })
              // );
              setOpenCreate(true);
            }}
            sx={{ margin: "20px", backgroundColor: variableStyles.MainColor }}
          >
            <Typography className="subtitle2-text" variant="subtitle2">
              Cập nhật Console
            </Typography>
          </Button>

          <Modal
            title="Cập nhật Google Console"
            textSubmit="Cập nhật"
            textClose="Huỷ bỏ"
            open={openCreate}
            onSubmit={handleSubmit(onSubmit)}
            onClose={() => {
              setOpenCreate(false);
              reset();
            }}
            loadingState={getGoooleAds.loading}
          >
            <form
              onSubmit={handleSubmit(onSubmit)}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px"
              }}
            >
              <ControlForm
                title="Google Console"
                isRequired
                classname="brand-form"
              >
                <InputForm
                  placeholder="Google Console"
                  required
                  name="iframeGoogleReport"
                  errors={errors}
                  control={control}
                  size="small"
                />
              </ControlForm>
            </form>
          </Modal>
        </div>
      </Box>
      <Box
        //flex={"1 1 auto"}
        sx={{
          margin: "0 20px",
          "& iframe ": {
            width: "100%",
            height: "750px"
          }
        }}
      >
        {goooleAds?.iframeGoogleReport && (
          <ReportEmbed iframeCode={goooleAds?.iframeGoogleReport} />
        )}

        {/* <iframe
          width={1500}
          height={700}
          src="https://lookerstudio.google.com/embed/reporting/8eee655e-c170-432c-9c2f-3399c894399e/page/VgD"
          frameBorder="0"
          style={{ border: 0 }}
          allowFullScreen
          sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        /> */}
      </Box>
    </GadsWrapper>
  );
};

export default GCSL;
